export default ({ get, checkStatus, toJSON }) => ({
  getShelf: (id) =>
    get(`universe/v1/home_page_shelves/search?shelves_ids=[${id}]`)
      .then(checkStatus)
      .then(toJSON),
  getDefaultShelf: (position) =>
    get(`universe/v1/home_page_shelves/default?position=${position}`)
      .then(checkStatus)
      .then(toJSON),
  getCustomShelf: (id) =>
    get(`/universe/v2/custom_shelves/search?custom_shelves_ids=${id}`)
      .then(checkStatus)
      .then(toJSON),
});
